import { createApiRequest } from "@/lib/api/createApiService";
import { SURVEY_LIBRARY_ENDPOINTS } from "./survey-library.endpoints";
export const surveyLibraryService = {
  listSurveys: async (params = {}, options = {}) => {
    return createApiRequest({
      url: SURVEY_LIBRARY_ENDPOINTS.LIST,
      method: "GET",
      body: params,
      ...options,
    });
  },

  createSurvey: async (payload, options = {}) => {
    return createApiRequest({
      url: SURVEY_LIBRARY_ENDPOINTS.CREATE,
      method: "POST",
      body: payload,
      ...options,
    });
  },

  getSurveyById: async (id, options = {}) => {
    return createApiRequest({
      url: SURVEY_LIBRARY_ENDPOINTS.GETSURVEYBYID(id),
      method: "GET",
      ...options,
    });
  },

  updateSurvey: async (id, payload, options = {}) => {
    return createApiRequest({
      url: SURVEY_LIBRARY_ENDPOINTS.UPDATE(id),
      method: "PUT",
      body: payload,
      ...options,
    });
  },

  deleteSurvey: async (id, options = {}) => {
    return createApiRequest({
      url: SURVEY_LIBRARY_ENDPOINTS.DELETE(id),
      method: "DELETE",
      ...options,
    });
  },
  closeSurvey: async (id, options = {}) => {
    return createApiRequest({
      url: SURVEY_LIBRARY_ENDPOINTS.CLOSE_SURVEY(id),
      method: "PATCH",
      ...options,
    });
  },
};
